module.exports = __webpack_public_path__ + "assets/img/llsj1.60c5c737.png";